'use client';
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigContext = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Context = (0, react_1.createContext)(null);
const ContextProvider = ({ children, appVersion = '', appEnv = 'staging', isMobile = false, }) => {
    const isMobileQuery = (0, material_1.useMediaQuery)('(max-width:600px)');
    const value = (0, react_1.useMemo)(() => ({
        appVersion,
        isMobile: isMobileQuery !== null && isMobileQuery !== void 0 ? isMobileQuery : isMobile,
        appEnv,
        isProduction: appEnv === 'production',
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isMobileQuery]);
    return react_1.default.createElement(Context.Provider, { value: value }, children);
};
exports.default = ContextProvider;
const useConfigContext = () => {
    const context = (0, react_1.useContext)(Context);
    if (!context) {
        throw new Error('Config context must be used within a Config Provider');
    }
    return context;
};
exports.useConfigContext = useConfigContext;
